<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_5">
				<span class="int_type_no_border mgr_5">
					<select class="tbl_select" v-model="search_date_type">
						<option value="P">P/O Date</option>
						<option value="S">Arr/ETA Date</option>
						<option value="R">Rcvd. Date</option>
					</select>
				</span>
				<span class="mgr_15"><CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect ph="Vendor" :showName="false" v-model="searched_partner" @set-partner="setPartner" /> </span>
				<span class="int_type mgr_15" style="width:240px;">
					<input type="text" v-model.trim="vendors_string" autocomplete="off" @focus="$event.target.select()" />
				</span>

				<em class="lt_text">P/O Status</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="po_status">
						<option value="A">ALL</option>
						<option value="E">Exclude Only on Order</option>
					</select>
				</span>

				<em class="lt_text">Item-Recived</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="received_status">
						<option value="A">ALL</option>
						<option value="Y">Received</option>
						<option value="N">Not Received</option>
					</select>
				</span>

				<em class="lt_text">P/O Closed</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="po_closed_status">
						<option value="A">ALL</option>
						<option value="Y">Closed</option>
						<option value="N">Not Closed</option>
					</select>
				</span>
			</div>
			<div class="left_option mgb_5">
				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type quarter3_int">
					<AC ref="ac" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </AC>
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" @keydown="search" />
				</span>

				<em class="lt_text">Item Color</em>
				<span class="int_type">
					<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<span>(Only Applied In Case Of Searching by {{ headers.class }}.)</span>
			</div>
			<div class="left_option mgb_5">
				<span class="int_type_no_border mgr_15">
					<ItemSelectMulti v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>

			<div class="fixed-table-container-none-padding">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable>
						<thead>
							<tr>
								<th width="5%">P/O No.</th>
								<th width="5%">
									<a href="javascript:;" @click="sort('po_date')">P/O Date{{ sortMark('po_date') }}</a>
								</th>
								<th width="7%">
									<a href="javascript:;" @click="sort('vendor_code')">Vendor Code{{ sortMark('vendor_code') }}</a>
								</th>
								<th width="7%">{{ headers.class }} Code</th>
								<th width="10%">
									<a href="javascript:;" @click="sort('item_code')">Item{{ sortMark('item_code') }}</a>
								</th>
								<th width="5%">Order Qty.</th>
								<th width="5%">Unit Price</th>
								<th width="7%">Order Amt.</th>
								<th width="5%">Sh. No.</th>
								<th width="5%">Arr. Date</th>
								<th width="5%">Shipped Qty.</th>
								<th width="7%">Shipped Amt.</th>
								<th width="5%">Rcvd. Date</th>
								<th width="5%">Rcvd. Qty.</th>
								<th width="7%">Rcvd. Amt.</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="p in purchase_list">
								<tr v-for="(s, index) in p.sh_list" :key="s.sh_item_no">
									<template v-if="index === 0">
										<td class="al_center" :rowspan="p.sh_list.length">{{ p.po_dn }}</td>
										<td class="al_center" :rowspan="p.sh_list.length">{{ p.po_date }}</td>
										<td class="al_left truncate" :rowspan="p.sh_list.length">{{ p.vendor_code }}</td>
										<td class="al_left truncate" :rowspan="p.sh_list.length">{{ p.class_code }}</td>
										<td class="al_left truncate" :rowspan="p.sh_list.length">{{ p.item_code }}</td>
										<td class="al_right" :rowspan="p.sh_list.length">{{ p.po_quantity | commaSeparated }}</td>
										<td class="al_right" :rowspan="p.sh_list.length">{{ p.po_price | toCurrency }}</td>
										<td class="al_right" :rowspan="p.sh_list.length">{{ p.po_amount | toCurrency }}</td>
									</template>
									<td class="al_center" :key="s.sh_item_no + '/0'">{{ s.sh_dn }}</td>
									<td class="al_center" :key="s.sh_item_no + '/1'">{{ s.arrival_date }}</td>
									<td class="al_right" :key="s.sh_item_no + '/2'">{{ s.shipped_quantity | commaSeparated }}</td>
									<td class="al_right" :key="s.sh_item_no + '/3'">{{ s.shipped_amount | toCurrency }}</td>
									<td class="al_center" :key="s.sh_item_no + '/4'">{{ s.received_date }}</td>
									<td class="al_right" :key="s.sh_item_no + '/5'">{{ s.received_quantity | commaSeparated }}</td>
									<td class="al_right" :key="s.sh_item_no + '/6'">{{ s.received_amount | toCurrency }}</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>

			<Paging ref="paging" v-on:gotoPage="search"></Paging>

			<div class="view_bottom_bt">
				<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
			</div>
		</div>
	</div>
</template>

<script>
import { daysAgo, today } from '@/utils/date.js';
import { apiPurchaseHistoryByGoods } from '@/api/report/report.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import AC from '@/components/common/AC';
export default {
	data: () => ({
		paging_yn: 'Y',
		page_no: 1,
		list_count: 0,

		search_date_type: null,
		date_from: null,
		date_to: null,

		po_status: null,
		received_status: null,
		po_closed_status: null,

		searched_partner: null,
		vendors_string: null,
		item_classes_string: null,
		colors_string: null,
		selected_items_str: null,
		separator: ',',

		purchase_list: [],

		saveParam: {},

		sort_key: 'item_code',
		sort_direction: 'ASC',
	}),
	components: {
		CustomDatePicker,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		AC,
		Paging,
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		page_size() {
			return this.$store.getters['getDefaultPageSize'];
		},
		item_classes() {
			return this.item_classes_string ? this.item_classes_string.split(this.separator) : [];
		},
		colors() {
			return this.colors_string ? this.colors_string.split(this.separator) : [];
		},
		vendors() {
			return this.vendors_string ? this.vendors_string.split(this.separator) : [];
		},
		selected_item_codes() {
			return this.selected_items_str ? this.selected_items_str.split(this.separator) : [];
		},
	},
	methods: {
		sortMark(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.search();
		},
		setPartner(vendor) {
			if (this.vendors_string) this.vendors_string += this.separator + vendor.code;
			else this.vendors_string = vendor.code;
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		async exportExcel() {
			if (!this.purchase_list) {
				this.$toast.error('No Data to Export.');
				return false;
			}
			let header = [
				{ key: 'po_dn', name: 'P/O No', width: 15, dataType: defaultDataType.string },
				{ key: 'po_date', name: 'P/O Date', width: 15, dataType: defaultDataType.string },
				{ key: 'vendor_code', name: 'Vendor Code', width: 15, dataType: defaultDataType.string },
				{ key: 'class_code', name: this.headers.class + ' Code', width: 15, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item', width: 25, dataType: defaultDataType.string },
				{ key: 'po_quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'po_price', name: 'Unit Price', width: 15, dataType: defaultDataType.number },
				{ key: 'po_amount', name: 'Order Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'sh_dn', name: 'Sh. No.', width: 15, dataType: defaultDataType.string },
				{ key: 'arrival_date', name: 'Arr. Date', width: 15, dataType: defaultDataType.string },
				{ key: 'shipped_quantity', name: 'Shipped Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'shipped_amount', name: 'Shipped Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'received_date', name: 'Rcvd. Date', width: 15, dataType: defaultDataType.string },
				{ key: 'received_quantity', name: 'Rcvd. Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'received_amount', name: 'Rcvd. Amt.', width: 15, dataType: defaultDataType.number },
			];

			const { data } = await apiPurchaseHistoryByGoods(this.saveParam);
			const excel_data = [];

			data.purchase_list.forEach(p => {
				p.sh_list.forEach((s, index) => {
					let obj = { ...s };
					if (index === 0) {
						for (const prop in p) {
							if (prop !== 'sh_list') obj[prop] = p[prop];
						}
					}

					excel_data.push(obj);
				});
			});

			exportDataExcel(excel_data, header, 'PurchaseHistoryByGoods');
		},
		async search(page_no) {
			this.page_no = page_no || 1;

			let { data } = await apiPurchaseHistoryByGoods({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				start_index: this.page_size * (this.page_no - 1),

				search_date_type: this.search_date_type,
				date_from: this.date_from,
				date_to: this.date_to,

				po_status: this.po_status,
				received_status: this.received_status,
				po_closed_status: this.po_closed_status,

				vendors: this.vendors,
				item_classes: this.item_classes,
				color_codes: this.colors,
				item_codes: this.selected_item_codes,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
			});
			this.purchase_list = data.purchase_list || [];
			this.list_count = data.list_count;

			this.saveParam = {
				search_date_type: this.search_date_type,
				date_from: this.date_from,
				date_to: this.date_to,

				po_status: this.po_status,
				received_status: this.received_status,
				po_closed_status: this.po_closed_status,

				vendors: this.vendors,
				item_classes: this.item_classes,
				color_codes: this.colors,
				item_codes: this.selected_item_codes,

				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
			};

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		reset() {
			this.search_date_type = 'P';
			this.date_from = daysAgo(14);
			this.date_to = today();

			this.po_status = 'A';
			this.received_status = 'A';
			this.po_closed_status = 'A';

			this.vendors_string = '';
			this.item_classes_string = '';
			this.colors_string = '';
			this.selected_items_str = '';

			if (this.user.company_id === 'minkhair') {
				this.search_date_type = 'S';
				this.po_status = 'E';
			}
		},
	},
	created() {
		this.reset();

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_purchase_history_by_goods');
		this.$store.commit('setSubTitle', 'Report -> Purchase History by Goods');
	},
};
</script>

<style></style>
